<template>
  <div class="publicSuccess">
    <div class="safe">
      <div class="successBox">
        <div class="title">
          兑换成功
        </div>
        <div class="mainCon">
          <div class="card">
            <div class="name">
              {{succesInfo[0].vip_name + '会员'}}·{{succesInfo[0].vip_type == 1 ? '月卡' : '年卡'}}
            </div>
            <div class="info">
              <div class="icon">
                <img :src="userInfo.userHeadImg" alt="">
              </div>
              <div class="rightInfo">
                <div class="count">
                  {{userInfo.userName}}
                </div>
                <div class="status">
                  {{formatDate(succesInfo[0].vip_deadline)}} 到期
                </div>
              </div>
            </div>
          </div>
          <div class="card card2">
            <div class="name">
              {{succesInfo[1].vip_name}}·{{succesInfo[1].vip_type == 1 ? '月卡' : '年卡'}}
            </div>
            <div class="info">
              <div class="icon">
                <img src="https://images.zhibo.tv/2021/0601/cctv_logo.png" alt="">
              </div>
              <div class="rightInfo">
                <div class="count">
                  {{conductMobile(succesInfo[1].mobile)}}
                </div>
                <div class="status">
                  {{succesInfo[1].status === 0 ? '请于' + formatDate(succesInfo[1].vip_expire) + '前激活' : '已激活'}}
                </div>
              </div>
            </div>
          </div>
          <div class="desc">
            激活方法：下载央视体育VIP App后，使用手机号：{{conductMobile(succesInfo[1].mobile)}}即可激活央视体育VIP会员
          </div>
          <div class="btn" @click="handleKnow">
            我知道了
          </div>
        </div>
        <!-- 关闭按钮 -->
        <div class="icon_close" @click="doClose">
          <img src="https://images.zhibo.tv/2021/0509/icon_cancel@3x.png" alt="">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['succesInfo','userInfo'],
  name: '',
  data () {
    return {}
  },
  computed: {
  },
  created () {
    console.log(this.succesInfo, 'succesInfo')
  },
  methods: {
    // 关闭
    doClose () {
      // 触发父组件中的dialogVisibleEvent事件，并传递参数
      this.$emit('showDialog', false);
    },
    // 我知道了
    handleKnow(){
      this.doClose()
    },
    // 转日期格式为两位数
    add0 (m) {
      return m < 10 ? '0' + m:m
    },
    // 格式化日期
    formatDate (item) {
      if (item) {
        let time = new Date(item * 1000) 
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let date = time.getDate()
        return year + '-' + this.add0(month) + '-' + this.add0(date)
      } else {
        return ''
      }
    },
    // 处理手机格式
    conductMobile(val) {
      let reg = /1(\d{2})\d{4}(\d{4})/g;
      return val && val.length > 0 ? val.replace(reg, "1$1****$2") : val
    }
  }
}
</script>

<style lang='less' scoped>
.publicSuccess {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  .safe {
    padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
    padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
  }
  .successBox {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    width: 5.6rem;
    height: 8.52rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    .title {
      width: 100%;
      box-sizing: border-box;
      padding: 0.4rem 0 0.32rem 0;
      border-bottom: 0.14vw solid #e5e5e5;
      font-size: 0.34rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222222;
      text-align: center;
      line-height: 0.48rem;
    }
    .mainCon {
      width: 100%;
      box-sizing: border-box;
      padding: 0.32rem 0.4rem 0.4rem 0.4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .card {
        width: 100%;
        margin-bottom: 0.4rem;
        .name {
          margin-bottom: 0.12rem;
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 0.4rem;
        }
        .info {
          width: 100%;
          background: #f7f7f7;
          border-radius: 0.12rem;
          box-sizing: border-box;
          padding: 0.12rem;
          display: flex;
          .icon {
            width: 1rem;
            height: 1rem;
            border-radius: 100%;
            overflow: hidden;
            justify-content: center;
            align-items: center;
            display: flex;
            img {
              display: block;
              width: 1rem;
              height: 1rem;
              object-fit: contain;
            }
          }
          .rightInfo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin: 0.12rem 0 0.12rem 0.12rem;
            .count {
              font-size: 0.24rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 0.32rem;
            }
            .status {
              font-size: 0.24rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 0.32rem;
            }
          }
        }
      }
      .card2 .icon{
        background: #18181A!important;
        img {
          width: .66rem!important;
        }
      }
      // 描述
      .desc {
        margin-bottom: 0.48rem;
        text-align: center;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.36rem;
      }
      // 我知道了按钮
      .btn {
        width: 3.2rem;
        height: 0.8rem;
        background: url('https://images.zhibo.tv/2021/0509/btn2@2x.png') no-repeat center;
        background-size: 100%;
        font-size: 0.28rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #984b26;
        text-align: center;
        line-height: 0.8rem;
      }
    }
    // 关闭按钮
    .icon_close {
      position: absolute;
      width: 0.32rem;
      height: 0.32rem;
      right: 0.24rem;
      top: 0.24rem;
      img {
        display: block;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
}
</style>
